import Vue from 'vue'
import Router from 'vue-router'
// import ItemList from '@/components/ItemList'

/* Views */
import Views from '@/views/Index'

/* Guide Content */
import ViewGuide from '@/views/Guide/Index'
import Content from '@/views/Guide/Content'

/* Themes */
import ViewThemes from '@/views/Themes/Index'

/* Article */
import ViewArticleList from '@/views/Article/ArticleList'
import ViewArticle from '@/views/Article/Article'

/* Test Posts */
import TestPosts from '@/components/Posts'
import TestArticle from '@/components/ArticleView'
import TestCategories from '@/components/Categories'
import TestPostcat from '@/components/Postcat'

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'uk-active',
  routes: [{
    path: '/',
    redirect: 'guide'
  }, {
    path: '/guide',
    component: ViewGuide,
    children: [{
      path: '/',
      component: Content
    }]
  }, {
    path: '/blog',
    component: Views,
    children: [{
      path: '/',
      component: ViewArticleList
    }]
  }, {
    path: '/blog/article',
    component: Views,
    children: [{
      path: '/',
      component: ViewArticle
    }]
  }, {
    path: '/posts',
    component: Views,
    children: [{
      path: '/',
      component: TestPosts
    }]
  }, {
    path: 'article',
    component: Views,
    children: [{
      path: '/',
      component: TestArticle
    }]
  }, {
    path: '/categories',
    component: Views,
    children: [{
      path: '/',
      component: TestCategories
    }]
  }, {
    path: '/postcat',
    component: Views,
    children: [{
      path: '/',
      component: TestPostcat
    }]
  }, {
    // 테마
    path: '/themes',
    component: Views,
    children: [{
      path: '/',
      component: ViewThemes
    }]
  }]
})
